import { Presentation, SlideMasterProps } from '@features/powerpoint';
import { ImageWithMetadata } from '@features/powerpoint';
import { slideMaster } from '@features/lci-report/slides';
import { sectionTitleSlideMaster } from '@features/lci-report/slides/shared/section-title-slide-master';
import { darkBackgroundSlideMaster } from '@features/lci-report/slides/shared/dark-background-slide-master';
import { layout } from '@features/lci-report/domain/dimensions';
import { DEFAULT_FONT } from '@features/lci-report/utils/constants';

type SharedPresentationProps = {
  campaign: {
    id: number;
    name: string;
  };
  brandLogo: ImageWithMetadata | null;
};

export const createSharedPresentationConfig = (
  props: SharedPresentationProps
): {
  filename: string;
  theme: { headFontFace: string; bodyFontFace: string };
  layout: Presentation['layout'];
  slideMasters: SlideMasterProps[];
} => {
  const { campaign, brandLogo } = props;
  const campaignName = campaign.name;

  const defaultSlideMaster: SlideMasterProps = slideMaster(brandLogo, {
    id: campaign.id,
    name: campaignName,
  });

  return {
    filename: `${campaignName}_lci_report.pptx`,
    theme: { headFontFace: DEFAULT_FONT, bodyFontFace: DEFAULT_FONT },
    layout,
    slideMasters: [
      defaultSlideMaster,
      sectionTitleSlideMaster,
      darkBackgroundSlideMaster(defaultSlideMaster),
    ],
  };
};
